// extracted by mini-css-extract-plugin
module.exports = {"app":"Modal_app__1ooDN","blurred":"Modal_blurred__2-YcC","modal":"Modal_modal__1vwov","content":"Modal_content__BZbGL","actions":"Modal_actions__34qLX"};